import React, { useState, useEffect } from "react";
import {
  Button,
  Col,
  Container,
  Form,
  Row,
  Table,
  Card,
} from "react-bootstrap";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import { IoSearch } from "react-icons/io5";
import InputGroup from "react-bootstrap/InputGroup";
import { JackInTheBox, Slide, Zoom } from "react-reveal";
import {
  getAllUpcommingApplicationForms,
  getAllListedApplicationForms,
  changeListingStatus,
  changeLiquidityListingStatus
} from "../../Action/action";
import {
  TokenSaleDuration,
  TokenPriceUsdt,
  PresaleTokenSupply,
  getTokenSupplyPresale,
} from "../../Web3/Connector";
import {
  getTokenPriceInfiSwap,
  getTokenSupplyInfiSwap,
  getTokenStatusInfiSwap,
} from "../../Web3/Liquidity/infiSwapConnector";
import {
  getTokenPriceSwap,
  getTokenSupplySwap,
  getTokenStatusSwap,
} from "../../Web3/Liquidity/swapConnector";
import config from "../../config";
import { Link, useNavigate, useParams, useLocation } from "react-router-dom";
import "./css/projectlist.css";
import { error } from "ajv/dist/vocabularies/applicator/dependencies";
import toast from "react-hot-toast";
import "@fortawesome/fontawesome-free/css/all.min.css";
import { useDisconnect, useAccount } from "wagmi";
import ReactApexChart from "react-apexcharts";

export default function ProjectList() {
  const navigate = useNavigate();
  //const loginDetails = useSelector((state) => state.auth.LoginDetails);
  //console.log('LOGO',loginDetails)
  const { address, isConnected } = useAccount();
  const [upcommings, setUpcommings] = useState([]);
  const [listed, setListed] = useState({
    presaleApplications: [],
    liquidityApplications: [],
    infiLiquidityApplications: [],
  });
  const [search, setSearch] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  // const _useWeb3WalletProvider = Web3WalletProvider()
  const [activeKey, setActiveKey] = useState("upcoming")
  const location = useLocation()

  useEffect(() => {
    const hash = location.hash.replace("#", "")
    if (hash) {
      setActiveKey(hash)
      setTimeout(() => {
        const element = document.getElementById("project-list")
        if (element) {
          element.scrollIntoView({ behavior: "smooth", block: "start" })
        }
      }, 200)
    } else {
      setActiveKey("upcoming")
    }
  }, [location.hash])

  const handleSelect = (k) => {
    setActiveKey(k)
    window.history.replaceState(null, null, `#${k}`)
    setTimeout(() => {
      const element = document.getElementById("project-list")
      if (element) {
        element.scrollIntoView({ behavior: "smooth", block: "start" })
      }
    }, 200)
  }

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 5000);

    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    getListingData()
    getUpcomingData()
  }, []);

  const getListingData = async () => {
    try {
      let list = await getAllListedApplicationForms();
      console.log("LISTED", list);

      if (list.success) {
        let res1, res2, res3, res4, res5, res6, res7, res8, d;

        if (list.data.presaleApplications.length > 0) {
          [res1, res2, d] = await Promise.all([
            getTokenSupplyPresale(list.data.presaleApplications),
            TokenPriceUsdt(list.data.presaleApplications),
            TokenSaleDuration(list.data.presaleApplications),
          ]);
          console.log("Presale Results", res1, res2);
        }

        if (list.data.liquidityApplications.length > 0) {
          [res3, res4, res5] = await Promise.all([
            getTokenSupplySwap(list.data.liquidityApplications),
            getTokenPriceSwap(list.data.liquidityApplications),
            getTokenStatusSwap(list.data.liquidityApplications),
          ]);
          console.log("Liquidity Results", res3, res4, res5);
        }

        if (list.data.infiLiquidityApplications.length > 0) {
          [res6, res7, res8] = await Promise.all([
            getTokenSupplyInfiSwap(list.data.infiLiquidityApplications),
            getTokenPriceInfiSwap(list.data.infiLiquidityApplications),
            getTokenStatusInfiSwap(list.data.infiLiquidityApplications),
          ]);
          console.log("InfiLiquidity Results", res6, res7, res8);
        }

        for (let i = 0; i < list.data.presaleApplications.length; i++) {
          list.data.presaleApplications[i].duration = d.duration[i] || "";
          list.data.presaleApplications[i].TOKEN_PRICE_PRESALE =
            res2?.data[i] || "";
          list.data.presaleApplications[i].PRE_TOTAL = res1?.data[i] || "";
        }

        for (let i = 0; i < list.data.liquidityApplications.length; i++) {
          list.data.liquidityApplications[i].TOKEN_PRICE_SWAP =
            res4?.data[i] || "";
          list.data.liquidityApplications[i].SWAP_TOTAL = res3?.data[i] || "";
          list.data.liquidityApplications[i].SWAP_STATUS = res5?.data[i];
        }

        for (let i = 0; i < list.data.infiLiquidityApplications.length; i++) {
          list.data.infiLiquidityApplications[i].TOKEN_PRICE_INFI_SWAP =
            res7?.data[i] || "";
          list.data.infiLiquidityApplications[i].INFI_TOTAL =
            res6?.data[i] || "";
          list.data.infiLiquidityApplications[i].SWAP_INFI_STATUS =
            res8?.data[i];
        }
        setListed(list.data);
        console.log("ll2", list);
      } else {
        toast.error("Error getting project list");
        console.log("Error getting project list", error);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const getUpcomingData = async () => {
    try {
      let up = await getAllUpcommingApplicationForms({});
      //console.log("upcoming", up);
      if (up.success) {
        if (up.data.length > 0) {
          setUpcommings(up.data);
          scheduleListing(up.data);
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  const scheduleListing = async (upcomingList) => {
    for (const item of upcomingList) {
      const startTime = new Date(item.startDateAndTime).getTime();
      const currentTime = Date.now();
      const delay = startTime - currentTime;
      //console.log(startTime, currentTime, delay, item.type, 'zxc');
      const triggerListing = async () => {
        try {
          if (item.type === 'SWAP') {
            await changeLiquidityListingStatus({ id: item.id });
          } else {
            await changeListingStatus({ id: item.id });
          }
          getUpcomingData();
        } catch (error) {
          console.error(`Error changing listing status for ${item.id}:`, error);
        }
      };

      if (delay > 0) {
        setTimeout(triggerListing, delay);
      } else {
        await triggerListing();
      }
    }
  };


  const openBuyModule = async (e, id, token_name) => {
    e.preventDefault();
    if (!isConnected) {
      toast.error("Please connect your wallet");
      return;
    } else {
      navigate(`${config.baseUrl}${id}/buy/${token_name}`);
      window.scrollTo(0, 0);
    }
  };

  const openClaimModule = async (e, id, token_name) => {
    e.preventDefault();
    if (!isConnected) {
      toast.error("Please connect your wallet");
      return;
    } else {
      console.log("kya", config.baseUrl);
      navigate(`${config.baseUrl}${id}/claim/${token_name}`);
      window.scrollTo(0, 0);
    }
  };

  //Swap
  const openSwapModule = async (e, id, token_name) => {
    e.preventDefault();
    if (!isConnected) {
      toast.error("Please connect your wallet");
      return;
    } else {
      navigate(`${config.baseUrl}${id}/swap/${token_name}_USDT`);
      window.scrollTo(0, 0);
    }
  };

  const openInfiSwapModule = async (e, id, token_name) => {
    e.preventDefault();
    if (!isConnected) {
      toast.error("Please connect your wallet.");
      return;
    } else {
      navigate(`${config.baseUrl}${id}infiSwap/${token_name}_INFI`);
      window.scrollTo(0, 0);
    }
  };

  const filterUpcoming = upcommings.filter(
    (item) =>
      item.token_name.toLowerCase().includes(search.toLowerCase()) ||
      item.pair_name?.toLowerCase().includes(search.toLowerCase())
  );

  const filterListed = {
    presale: (listed.presaleApplications || []).filter((item) =>
      item.token_name.toLowerCase().includes(search.toLowerCase())
    ),
    swap: [
      ...(listed.liquidityApplications || []),
      ...(listed.infiLiquidityApplications || []),
    ].filter(
      (item) =>
        item.token_name.toLowerCase().includes(search.toLowerCase()) ||
        (item.pair_name ?? "").toLowerCase().includes(search.toLowerCase())
    ),
  };

  function formatLargeNumber(number) {
    if (number === null || number === undefined || number === "") {
      return "";
    }

    if (number >= 1e12) {
      return number / 1e12 + "T"; // Trillions
    } else if (number >= 1e9) {
      return number / 1e9 + "B"; // Billions
    } else if (number >= 1e6) {
      return number / 1e6 + "M"; // Millions
    } else if (number >= 1e3) {
      return number / 1e3 + "K"; // Thousands
    } else {
      return number.toString();
    }
  }

  const formatPrice = (price) => {
    return price < 0.0001
      ? Number(price).toFixed(11)
      : parseFloat(Number(price)).toString();
  };

  const chartStyle = {
    maxWidth: "400px",
    padding: "0px",
    background: "transparent",
    borderRadius: "0px",
  };

  const isPresaleEnded = (item) => {
    return item.duration;
  };


  return (
    <>
      <section className="projectList py-5 darktheme">
        <Container>
          <div>
            <div className="d-md-flex justify-content-between">
              <div className="mb-5">
                <Slide left>
                  <div className="position-relative d-inline-block text-left">
                    <div className="polygon" style={{ right: "-78px" }}>
                      <img src="images/shape/polygon.png" alt="" />
                    </div>
                    <h1
                      id="project-list"
                      className="position-relative text-white"
                    >
                      Project List
                    </h1>
                  </div>
                </Slide>
              </div>
              <div className="d-flex align-items-center gap-3 mb-5">
                <InputGroup className="">
                  <InputGroup.Text id="basic-addon1">
                    <IoSearch />
                  </InputGroup.Text>
                  <Form.Control
                    placeholder="Search by Token Name, Pair Name"
                    aria-describedby="basic-addon1"
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                    className="ps-0 bg-white text-black"
                  />
                </InputGroup>
              </div>
            </div>
          </div>

          <Tabs
            activeKey={activeKey}
            onSelect={handleSelect}
            className="mb-3"
          >
            <Tab
              eventKey="upcoming"
              title={`Upcoming [${filterUpcoming && filterUpcoming.length}]`}
            >
              {isLoading ?
                <div className="p-sm-4 text-center">
                  <img
                    src={`${config.baseUrl}images/loader.gif`}
                    width="30px"
                    alt=""
                  />
                </div>
                :
                <div>
                  <Row>
                    {filterUpcoming && filterUpcoming.length > 0 ? (
                      filterUpcoming.map((item) =>
                        item.type === "Presale ICO" ? (
                          <Col md={6} lg={4} className="mt-4">
                            <Zoom>
                              <div className="card">
                                <div className="p-4">
                                  <div className="text-center img_wrapper">
                                    <img
                                      src={`${config.imagePath}${item.brand_logo}`}
                                      alt=""
                                      className="img-fluid crd_img"
                                    />
                                  </div>
                                  <div className="d-flex justify-content-between align-items-center mb-3 mt-4">
                                    <b className="fs-3">{item.token_name}</b>
                                    <div>
                                      <img
                                        src={`${config.imagePath}${item.chainName}.png`}
                                        alt=""
                                        width={35}
                                      />
                                    </div>
                                  </div>
                                  <div className="mb-4">
                                    <div className="projectContent">
                                      <div className="d-flex justify-content-between mb-2">
                                        <span className=" text-light-grey">
                                          {" "}
                                          Token Amount{" "}
                                        </span>
                                        <b className="fs-6">
                                          {formatLargeNumber(item.token_amount)}
                                        </b>
                                      </div>

                                      <div className="d-flex justify-content-between mb-2">
                                        <span className=" text-light-grey">
                                          {" "}
                                          Price{" "}
                                        </span>
                                        <b className="fs-6">
                                          ${" "}
                                          {item.usdt_price < 0.0001
                                            ? item.usdt_price
                                            : parseFloat(
                                              item.usdt_price
                                            ).toString()}
                                        </b>
                                      </div>

                                      <div className="d-flex justify-content-between mb-2">
                                        <span className=" text-light-grey">
                                          {" "}
                                          Start Date & Time{" "}
                                        </span>
                                        <b className="fs-6 text-end">
                                          {new Date(
                                            item.startDateAndTime
                                          ).toLocaleString("en-US", {
                                            weekday: "short",
                                            day: "2-digit",
                                            month: "short",
                                            year: "numeric",
                                            hour: "2-digit",
                                            minute: "2-digit",
                                            hour12: true,
                                          })}
                                        </b>
                                      </div>
                                      <div className="d-flex justify-content-between mb-2">
                                        <span className=" text-light-grey">
                                          Type
                                        </span>
                                        <b className="fs-6">{item.type}</b>
                                      </div>
                                      <div className="d-flex justify-content-between mb-2">
                                        <span className=" text-light-grey">
                                          Website
                                        </span>
                                        {item.website && (
                                          <a
                                            className="fs-6 text-decoration-none"
                                            href={item.website}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                          >
                                          </a>
                                        )}
                                      </div>
                                      <div className="d-flex justify-content-between mb-2">
                                        <span className=" text-light-grey">
                                          Socials
                                        </span>
                                        <div className="fs-6 d-flex gap-3">
                                          {(() => {
                                            let socials = [];
                                            try {
                                              socials = JSON.parse(
                                                item?.social_accounts
                                              );
                                            } catch (error) {
                                              console.error(
                                                "Error parsing social accounts:",
                                                error
                                              );
                                            }
                                            const socialStyles = {
                                              twitter: {
                                                icon: "fab fa-x-twitter",
                                                color: "#0077B5",
                                              },
                                              facebook: {
                                                icon: "fab fa-facebook",
                                                color: "#1877F2",
                                              },
                                              instagram: {
                                                icon: "fab fa-instagram",
                                                color: "#E1306C",
                                              },
                                              linkedin: {
                                                icon: "fab fa-linkedin",
                                                color: "#0077B5",
                                              },
                                              github: {
                                                icon: "fab fa-github",
                                                color: "#333",
                                              },
                                              telegram: {
                                                icon: "fab fa-telegram",
                                                color: "#0088cc",
                                              },
                                              discord: {
                                                icon: "fab fa-discord",
                                                color: "#5865F2",
                                              },
                                              youtube: {
                                                icon: "fab fa-youtube",
                                                color: "#FF0000",
                                              },
                                            };
                                            return Array.isArray(socials) &&
                                              socials.length > 0 ? (
                                              socials.map((social, index) => {
                                                const socialData = socialStyles[
                                                  social.name.toLowerCase()
                                                ] || {
                                                  icon: "fas fa-link",
                                                  color: "#fff",
                                                };
                                                return (
                                                  <a
                                                    key={index}
                                                    href={social.link}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    className="text-decoration-none"
                                                  >
                                                    <i
                                                      className={`${socialData.icon} fs-6`}
                                                      style={{
                                                        color: socialData.color,
                                                      }}
                                                    ></i>
                                                  </a>
                                                );
                                              })
                                            ) : (
                                              <span className="text-muted">
                                                No social accounts available
                                              </span>
                                            );
                                          })()}
                                        </div>
                                      </div>

                                      <div id="chart" style={chartStyle}>
                                        {(() => {
                                          const series = [
                                            item.private_sale || 0,
                                            item.ico || 0,
                                            item.team || 0,
                                            item.partnerships || 0,
                                            item.others || 0,
                                          ];
                                          const chartOptions = {
                                            chart: {
                                              type: "donut",
                                            },
                                            labels: [
                                              "Private Sale",
                                              "ICO",
                                              "Team",
                                              "Partnerships",
                                              "Others",
                                            ],
                                            responsive: [
                                              {
                                                breakpoint: 480,
                                                options: {
                                                  chart: {
                                                    width: "100%",
                                                  },
                                                  legend: {
                                                    position: "bottom",
                                                  },
                                                },
                                              },
                                            ],
                                          };
                                          return (
                                            <ReactApexChart
                                              options={chartOptions}
                                              series={series}
                                              type="donut"
                                            />
                                          );
                                        })()}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </Zoom>
                          </Col>
                        ) : (
                          <Col md={6} lg={4} className="mt-4">
                            <Zoom>
                              <div className="card">
                                <div className="p-4">
                                  <div className="text-center img_wrapper">
                                    <img
                                      src={`${config.imagePath}${item.brand_logo}`}
                                      alt=""
                                      className="img-fluid crd_img"
                                    />
                                  </div>
                                  <div className="d-flex justify-content-between align-items-center mb-3 mt-4">
                                    <b className="fs-3">{item.token_name}</b>
                                    <div>
                                      <img
                                        src={`${config.imagePath}${item.chainName}.png`}
                                        alt=""
                                        width={35}
                                      />
                                    </div>
                                  </div>

                                  <div className="mb-4">
                                    <div className="projectContent">
                                      <div className="d-flex justify-content-between mb-2">
                                        <span className=" text-light-grey">
                                          {" "}
                                          Pair{" "}
                                        </span>
                                        <b className="fs-6">{item.pair_name}</b>
                                      </div>

                                      <div className="d-flex justify-content-between mb-2">
                                        <span className=" text-light-grey">
                                          {" "}
                                          Project Type{" "}
                                        </span>
                                        <b className="fs-6">{item.type}</b>
                                      </div>

                                      <div className="d-flex justify-content-between mb-2">
                                        <span className=" text-light-grey">
                                          {" "}
                                          Start Date & Time{" "}
                                        </span>
                                        <b className="fs-6 text-end">
                                          {new Date(
                                            item.startDateAndTime
                                          ).toLocaleString("en-US", {
                                            weekday: "short",
                                            day: "2-digit",
                                            month: "short",
                                            year: "numeric",
                                            hour: "2-digit",
                                            minute: "2-digit",
                                            hour12: true,
                                          })}
                                        </b>
                                      </div>

                                      <div className="d-flex justify-content-between mb-2">
                                        <span className=" text-light-grey">
                                          Website
                                        </span>
                                        {item.website && (
                                          <a
                                            className="fs-6 text-decoration-none"
                                            href={item.website}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                          >
                                          </a>
                                        )}
                                      </div>

                                      <div className="d-flex justify-content-between mb-2">
                                        <span className=" text-light-grey">
                                          Socials
                                        </span>
                                        <div className="fs-6 d-flex gap-3">
                                          {(() => {
                                            let socials = [];

                                            try {
                                              socials = JSON.parse(
                                                item?.social_accounts
                                              );
                                            } catch (error) {
                                              console.error(
                                                "Error parsing social accounts:",
                                                error
                                              );
                                            }

                                            const socialStyles = {
                                              twitter: {
                                                icon: "fab fa-x-twitter",
                                                color: "#000000",
                                              },
                                              facebook: {
                                                icon: "fab fa-facebook",
                                                color: "#1877F2",
                                              },
                                              instagram: {
                                                icon: "fab fa-instagram",
                                                color: "#E1306C",
                                              },
                                              linkedin: {
                                                icon: "fab fa-linkedin",
                                                color: "#0077B5",
                                              },
                                              github: {
                                                icon: "fab fa-github",
                                                color: "#333",
                                              },
                                              telegram: {
                                                icon: "fab fa-telegram",
                                                color: "#0088cc",
                                              },
                                              discord: {
                                                icon: "fab fa-discord",
                                                color: "#5865F2",
                                              },
                                              youtube: {
                                                icon: "fab fa-youtube",
                                                color: "#FF0000",
                                              },
                                            };

                                            return Array.isArray(socials) &&
                                              socials.length > 0 ? (
                                              socials.map((social, index) => {
                                                const socialData = socialStyles[
                                                  social.name.toLowerCase()
                                                ] || {
                                                  icon: "fas fa-link",
                                                  color: "#fff",
                                                };

                                                return (
                                                  <a
                                                    key={index}
                                                    href={social.link}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    className="text-decoration-none"
                                                  >
                                                    <i
                                                      className={`${socialData.icon} fs-3`}
                                                      style={{
                                                        color: socialData.color,
                                                      }}
                                                    ></i>
                                                  </a>
                                                );
                                              })
                                            ) : (
                                              <span className="text-muted">
                                                No social accounts available
                                              </span>
                                            );
                                          })()}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </Zoom>
                          </Col>
                        )
                      )
                    ) : (
                      <div className="text-center cardStyle">
                        <Card className=" py-5">
                          <p className="mb-0">No upcoming projects available</p>
                        </Card>
                      </div>
                    )}
                  </Row>
                </div>}
            </Tab>
            <Tab
              eventKey="ended"
              title={`Ended [${filterListed.presale
                  ? filterListed.presale.filter(
                    (item) =>
                      item.type === "Presale ICO" && isPresaleEnded(item)
                  ).length
                  : 0
                }]`}
            >
              {isLoading ?
                <div className="p-sm-4 text-center">
                  <img
                    src={`${config.baseUrl}images/loader.gif`}
                    width="30px"
                    alt=""
                  />
                </div>
                :
                <div>
                  <Row>
                    {filterListed.presale && filterListed.presale.length > 0
                      ? filterListed.presale.map((item) =>
                        item.type === "Presale ICO" && isPresaleEnded(item) ? (
                          <Col md={6} lg={4} className="mt-4">
                            <Zoom>
                              <div className="card">
                                <div className="p-4">
                                  <div className="text-center img_wrapper">
                                    <img
                                      src={`${config.imagePath}${item.brand_logo}`}
                                      alt=""
                                      className="img-fluid crd_img"
                                    />
                                  </div>
                                  <div className="d-flex justify-content-between align-items-center mb-3 mt-4">
                                    <b className="fs-3">{item.token_name}</b>
                                    <div>
                                      <img
                                        src={`${config.imagePath}${item.chainName}.png`}
                                        alt=""
                                        width={35}
                                      />
                                    </div>
                                  </div>
                                  <div className="">
                                    <div className="projectContent">
                                      <div className="d-flex justify-content-between mb-2">
                                        <span className=" text-light-grey">
                                          {" "}
                                          Token Amount{" "}
                                        </span>
                                        <b className="fs-6">
                                          {formatLargeNumber(item.token_amount)}
                                        </b>
                                      </div>

                                      <div className="d-flex justify-content-between mb-2">
                                        <span className=" text-light-grey">
                                          {" "}
                                          Price{" "}
                                        </span>
                                        <b className="fs-6">
                                          ${" "}
                                          {item.usdt_price < 0.0001
                                            ? item.usdt_price
                                            : parseFloat(
                                              item.usdt_price
                                            ).toString()}
                                        </b>
                                      </div>

                                      <div className="d-flex justify-content-between mb-2">
                                        <span className=" text-light-grey">
                                          {" "}
                                          Start Date & Time{" "}
                                        </span>
                                        <b className="fs-6 text-end">
                                          {new Date(
                                            item.startDateAndTime
                                          ).toLocaleString("en-US", {
                                            weekday: "short",
                                            day: "2-digit",
                                            month: "short",
                                            year: "numeric",
                                            hour: "2-digit",
                                            minute: "2-digit",
                                            hour12: true,
                                          })}
                                        </b>
                                      </div>
                                      <div className="d-flex justify-content-between mb-2">
                                        <span className=" text-light-grey">
                                          Type
                                        </span>
                                        <b className="fs-9">{item.type}</b>
                                      </div>
                                      <div className="d-flex justify-content-between mb-2">
                                        <span className=" text-light-grey">
                                          Website
                                        </span>
                                        {item.website && (
                                          <a
                                            className="fs-6 text-decoration-none"
                                            href={item.website}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                          >
                                          </a>
                                        )}
                                      </div>
                                      <div className="d-flex justify-content-between mb-2">
                                        <span className=" text-light-grey">
                                          Socials
                                        </span>
                                        <div className="fs-6 d-flex gap-3">
                                          {(() => {
                                            let socials = [];
                                            try {
                                              socials = JSON.parse(
                                                item?.social_accounts
                                              );
                                            } catch (error) {
                                              console.error(
                                                "Error parsing social accounts:",
                                                error
                                              );
                                            }
                                            const socialStyles = {
                                              twitter: {
                                                icon: "fab fa-x-twitter",
                                                color: "#0077B5",
                                              },
                                              facebook: {
                                                icon: "fab fa-facebook",
                                                color: "#1877F2",
                                              },
                                              instagram: {
                                                icon: "fab fa-instagram",
                                                color: "#E1306C",
                                              },
                                              linkedin: {
                                                icon: "fab fa-linkedin",
                                                color: "#0077B5",
                                              },
                                              github: {
                                                icon: "fab fa-github",
                                                color: "#333",
                                              },
                                              telegram: {
                                                icon: "fab fa-telegram",
                                                color: "#0088cc",
                                              },
                                              discord: {
                                                icon: "fab fa-discord",
                                                color: "#5865F2",
                                              },
                                              youtube: {
                                                icon: "fab fa-youtube",
                                                color: "#FF0000",
                                              },
                                            };
                                            return Array.isArray(socials) &&
                                              socials.length > 0 ? (
                                              socials.map((social, index) => {
                                                const socialData = socialStyles[
                                                  social.name.toLowerCase()
                                                ] || {
                                                  icon: "fas fa-link",
                                                  color: "#fff",
                                                };
                                                return (
                                                  <a
                                                    key={index}
                                                    href={social.link}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    className="text-decoration-none"
                                                  >
                                                    <i
                                                      className={`${socialData.icon} fs-6`}
                                                      style={{
                                                        color: socialData.color,
                                                      }}
                                                    ></i>
                                                  </a>
                                                );
                                              })
                                            ) : (
                                              <span className="text-muted">
                                                No social accounts available
                                              </span>
                                            );
                                          })()}
                                        </div>
                                      </div>
                                      <div id="chart" style={chartStyle}>
                                        {(() => {
                                          const series = [
                                            item.private_sale || 0,
                                            item.ico || 0,
                                            item.team || 0,
                                            item.partnerships || 0,
                                            item.others || 0,
                                          ];
                                          const chartOptions = {
                                            chart: {
                                              type: "donut",
                                            },
                                            labels: [
                                              "Private Sale",
                                              "ICO",
                                              "Team",
                                              "Partnerships",
                                              "Others",
                                            ],

                                            responsive: [
                                              {
                                                breakpoint: 480,
                                                options: {
                                                  chart: {
                                                    width: "100%",
                                                  },
                                                  legend: {
                                                    position: "bottom",
                                                  },
                                                },
                                              },
                                            ],
                                          };
                                          return (
                                            <ReactApexChart
                                              options={chartOptions}
                                              series={series}
                                              type="donut"
                                            />
                                          );
                                        })()}
                                      </div>
                                      <Button
                                        variant="default"
                                        onClick={(e) =>
                                          openClaimModule(
                                            e,
                                            item.id,
                                            item.token_name
                                          )
                                        }
                                        className="w-100 bg-white mt-3 text-black"
                                      >
                                        View Details
                                      </Button>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </Zoom>
                          </Col>
                        ) : (""
                        )
                      )
                      :
                      <div className="text-center cardStyle">
                        <Card className=" py-5">
                          <p className="mb-0">No projects available</p>
                        </Card>
                      </div>}
                  </Row>
                </div>}
            </Tab>
            <Tab
              eventKey="activepresale"
              title={`Active Presale [${filterListed.presale
                  ? filterListed.presale.filter(
                    (item) =>
                      item.type === "Presale ICO" && !isPresaleEnded(item)
                  ).length
                  : 0
                }]`}
            >
              {isLoading ?
                <div className="p-sm-4 text-center">
                  <img
                    src={`${config.baseUrl}images/loader.gif`}
                    width="30px"
                    alt=""
                  />
                </div>
                :
                <div>
                  <Row>
                    {filterListed.presale && filterListed.presale.length > 0 ? (
                      (() => {
                        const activePresales = filterListed.presale.filter(
                          (item) => item.type === "Presale ICO" && !isPresaleEnded(item)
                        );
                        return activePresales.length > 0 ? (
                          activePresales.map((item, index) => (
                            <Col key={index} md={6} lg={4} className="mt-4">
                              <Zoom>
                                <div className="cardStyle">
                                  <Card className="">
                                    <div className="p-4">
                                      <div className="text-center img_wrapper">
                                        <img
                                          src={`${config.imagePath}${item.brand_logo}`}
                                          alt=""
                                          className="img-fluid crd_img"
                                        />
                                      </div>
                                      <div className="d-flex justify-content-between align-items-center mb-3 mt-4">
                                        <b className="fs-3">{item.token_name}</b>
                                        <div>
                                          <img
                                            src={`${config.imagePath}${item.chainName}.png`}
                                            alt=""
                                            width={35}
                                          />
                                        </div>
                                      </div>
                                      <div className="">
                                        <div className="projectContent">
                                          <div className="d-flex justify-content-between mb-2">
                                            <span className=" text-light-grey">
                                              {" "}
                                              Token Amount{" "}
                                            </span>
                                            <b className="fs-6">
                                              {formatLargeNumber(
                                                item.token_amount
                                              )}
                                            </b>
                                          </div>

                                          <div className="d-flex justify-content-between mb-2">
                                            <span className=" text-light-grey">
                                              {" "}
                                              Price{" "}
                                            </span>
                                            <b className="fs-6">
                                              ${" "}
                                              {item.usdt_price < 0.0001
                                                ? item.usdt_price
                                                : parseFloat(
                                                  item.usdt_price
                                                ).toString()}
                                            </b>
                                          </div>

                                          <div className="d-flex justify-content-between mb-2">
                                            <span className=" text-light-grey">
                                              {" "}
                                              Start Date & Time{" "}
                                            </span>
                                            <b className="fs-6 text-end">
                                              {new Date(
                                                item.startDateAndTime
                                              ).toLocaleString("en-US", {
                                                weekday: "short",
                                                day: "2-digit",
                                                month: "short",
                                                year: "numeric",
                                                hour: "2-digit",
                                                minute: "2-digit",
                                                hour12: true,
                                              })}
                                            </b>
                                          </div>
                                          {/* <div className="d-flex justify-content-between mb-2">
                                <span className=" text-light-grey">Type</span>
                                 <b className="fs-6">{item.type}</b>
                              </div> */}
                                          <div className="d-flex justify-content-between mb-2">
                                            <span className=" text-light-grey">
                                              Website
                                            </span>
                                            {item.website && (
                                              <a
                                                className="fs-6 text-decoration-none"
                                                href={item.website}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                              >
                                              </a>
                                            )}
                                          </div>
                                          <div className="d-flex justify-content-between mb-2">
                                            <span className=" text-light-grey">
                                              Socials
                                            </span>
                                            <div className="fs-6 d-flex gap-3">
                                              {(() => {
                                                let socials = [];
                                                try {
                                                  socials = JSON.parse(
                                                    item?.social_accounts
                                                  );
                                                } catch (error) {
                                                  console.error(
                                                    "Error parsing social accounts:",
                                                    error
                                                  );
                                                }
                                                const socialStyles = {
                                                  twitter: {
                                                    icon: "fab fa-x-twitter",
                                                    color: "#0077B5",
                                                  },
                                                  facebook: {
                                                    icon: "fab fa-facebook",
                                                    color: "#1877F2",
                                                  },
                                                  instagram: {
                                                    icon: "fab fa-instagram",
                                                    color: "#E1306C",
                                                  },
                                                  linkedin: {
                                                    icon: "fab fa-linkedin",
                                                    color: "#0077B5",
                                                  },
                                                  github: {
                                                    icon: "fab fa-github",
                                                    color: "#333",
                                                  },
                                                  telegram: {
                                                    icon: "fab fa-telegram",
                                                    color: "#0088cc",
                                                  },
                                                  discord: {
                                                    icon: "fab fa-discord",
                                                    color: "#5865F2",
                                                  },
                                                  youtube: {
                                                    icon: "fab fa-youtube",
                                                    color: "#FF0000",
                                                  },
                                                };
                                                return Array.isArray(socials) &&
                                                  socials.length > 0 ? (
                                                  socials.map((social, index) => {
                                                    const socialData =
                                                      socialStyles[
                                                      social.name.toLowerCase()
                                                      ] || {
                                                        icon: "fas fa-link",
                                                        color: "#fff",
                                                      };
                                                    return (
                                                      <a
                                                        key={index}
                                                        href={social.link}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                        className="text-decoration-none"
                                                      >
                                                        <i
                                                          className={`${socialData.icon} fs-6`}
                                                          style={{
                                                            color:
                                                              socialData.color,
                                                          }}
                                                        ></i>
                                                      </a>
                                                    );
                                                  })
                                                ) : (
                                                  <span className="text-muted">
                                                    No social accounts available
                                                  </span>
                                                );
                                              })()}
                                            </div>
                                          </div>
                                          <div id="chart" style={chartStyle}>
                                            {(() => {
                                              const series = [
                                                item.private_sale || 0,
                                                item.ico || 0,
                                                item.team || 0,
                                                item.partnerships || 0,
                                                item.others || 0,
                                              ];
                                              const chartOptions = {
                                                chart: {
                                                  type: "donut",
                                                },
                                                labels: [
                                                  "Private Sale",
                                                  "ICO",
                                                  "Team",
                                                  "Partnerships",
                                                  "Others",
                                                ],
                                                responsive: [
                                                  {
                                                    breakpoint: 480,
                                                    options: {
                                                      chart: {
                                                        width: "100%",
                                                      },
                                                      legend: {
                                                        position: "bottom",
                                                      },
                                                    },
                                                  },
                                                ],
                                              };
                                              return (
                                                <ReactApexChart
                                                  options={chartOptions}
                                                  series={series}
                                                  type="donut"
                                                />
                                              );
                                            })()}
                                          </div>
                                          <Button
                                            variant="default"
                                            onClick={(e) =>
                                              openBuyModule(
                                                e,
                                                item.id,
                                                item.token_name
                                              )
                                            }
                                            className="w-100 bg-white mt-3 text-black"
                                          >
                                            Buy
                                          </Button>
                                        </div>
                                      </div>
                                    </div>
                                  </Card>
                                </div>
                              </Zoom>
                            </Col>)))
                          :
                          (
                            <Col xs={12}>
                              <div className="text-center cardStyle mb-3">
                                <Card className=" py-5">
                                  <p className="mb-0">No projects active</p>
                                </Card>
                              </div>
                            </Col>)
                      })()) : (
                      <div className="text-center cardStyle mb-3">
                        <Card className=" py-5">
                          <p className="mb-0">No projects available</p>
                        </Card>
                      </div>)}
                  </Row>
                </div>}
            </Tab>

            <Tab
              eventKey="listed"
              title={`Listed [${filterListed.swap && filterListed.swap.length
                }]`}
            >
              {isLoading ?
                <div className="p-sm-4 text-center">
                  <img
                    src={`${config.baseUrl}images/loader.gif`}
                    width="30px"
                    alt=""
                  />
                </div>
                :
                <div>
                  <Row>
                    <Col md={12} lg={12} className="">
                      <Zoom>
                        <div className="listed">
                          <Table responsive className="bg-transparent text-white border-dark">
                            <thead>
                              <tr>
                                <th>Name</th>
                                <th>Chain</th>
                                <th>Price</th>
                                <th>Project Type</th>
                                <th>Total Supply</th>
                                <th>Status</th>
                                <th>&nbsp;</th>
                              </tr>
                            </thead>
                            <tbody>
                              {filterListed.swap &&
                                filterListed.swap.length > 0 ? (
                                filterListed.swap.map((item) => (
                                  <tr
                                    key={item.id}
                                    style={{
                                      border:
                                        item.type === "SPECIAL INFI SWAP"
                                          ? "2px solid #00bfff"
                                          : "",
                                      boxShadow:
                                        item.type === "SPECIAL INFI SWAP"
                                          ? "0 0 8px #00bfff"
                                          : "",
                                      color: "#fff",
                                      transition: "box-shadow 0.3s ease",
                                    }}
                                  >
                                    <td>
                                      <div className="d-flex align-items-center lh-1">
                                        <div className="me-2">
                                          <img
                                            src={`${config.imagePath}${item.brand_logo}`}
                                            width="28px"
                                            alt="logo"
                                          />
                                        </div>
                                        <div className="lh-1">
                                          <h5 className="mb-0">
                                            {item.pair_name}
                                          </h5>
                                        </div>
                                      </div>
                                    </td>
                                    <td>{item.chainName}</td>
                                    <td>
                                      {isLoading ? (
                                        <div className="p-sm-4 text-center">
                                          <img
                                            src={`${config.baseUrl}images/loader.gif`}
                                            width="30px"
                                            alt=""
                                          />
                                        </div>
                                      ) : item.pair_name ===
                                        `${item.token_name}/INFI` ? (
                                        `${formatPrice(
                                          item.TOKEN_PRICE_INFI_SWAP
                                        )} ${item.token_name}/INFI`
                                      ) : (
                                        `$${formatPrice(item.TOKEN_PRICE_SWAP)}`
                                      )}
                                    </td>
                                    <td>{item.type}</td>
                                    <td>
                                      {isLoading ? (
                                        <div className="p-sm-4 text-center">
                                          <img
                                            src={`${config.baseUrl}images/loader.gif`}
                                            width="30px"
                                            alt=""
                                          />
                                        </div>
                                      ) : item.pair_name ===
                                        `${item.token_name}/INFI` ? (
                                        formatLargeNumber(item.INFI_TOTAL)
                                      ) : (
                                        formatLargeNumber(item.SWAP_TOTAL)
                                      )}
                                    </td>
                                    <td>
                                      {isLoading ? (
                                        <div className="p-sm-4 text-center">
                                          <img
                                            src={`${config.baseUrl}images/loader.gif`}
                                            width="30px"
                                            alt=""
                                          />
                                        </div>
                                      ) : item.pair_name ===
                                        `${item.token_name}/INFI` ? (
                                        item.SWAP_INFI_STATUS ? (
                                          <>
                                            <span
                                              style={{
                                                height: "8px",
                                                width: "8px",
                                                backgroundColor: "red",
                                                borderRadius: "50%",
                                                display: "inline-block",
                                                marginRight: "5px",
                                              }}
                                            ></span>
                                            Paused
                                          </>
                                        ) : (
                                          <>
                                            <span
                                              style={{
                                                height: "8px",
                                                width: "8px",
                                                backgroundColor: "green",
                                                borderRadius: "50%",
                                                display: "inline-block",
                                                marginRight: "5px",
                                              }}
                                            ></span>
                                            Active
                                          </>
                                        )
                                      ) : item.SWAP_STATUS ? (
                                        <>
                                          <span
                                            style={{
                                              height: "8px",
                                              width: "8px",
                                              backgroundColor: "red",
                                              borderRadius: "50%",
                                              display: "inline-block",
                                              marginRight: "5px",
                                            }}
                                          ></span>
                                          Paused
                                        </>
                                      ) : (
                                        <>
                                          <span
                                            style={{
                                              height: "8px",
                                              width: "8px",
                                              backgroundColor: "green",
                                              borderRadius: "50%",
                                              display: "inline-block",
                                              marginRight: "5px",
                                            }}
                                          ></span>
                                          Active
                                        </>
                                      )}
                                    </td>
                                    <td>
                                      <Button
                                        variant="dark"
                                        onClick={(e) => {
                                          if (
                                            item.pair_name ===
                                            `${item.token_name}/INFI`
                                          ) {
                                            openInfiSwapModule(
                                              e,
                                              item.id,
                                              item.token_name
                                            );
                                          } else {
                                            openSwapModule(
                                              e,
                                              item.id,
                                              item.token_name
                                            );
                                          }
                                        }}
                                        disabled={
                                          item.pair_name ===
                                            `${item.token_name}/INFI`
                                            ? item.SWAP_INFI_STATUS
                                            : item.SWAP_STATUS
                                        }
                                      >
                                        Trade
                                      </Button>
                                    </td>
                                  </tr>
                                ))
                              ) : (
                                <tr>
                                  <td
                                    colSpan="7"
                                    className="text-center"
                                    style={{ color: "white", fontWeight: "bold" }}
                                  >
                                    No listed projects available
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </Table>
                        </div>
                      </Zoom>
                    </Col>
                  </Row>
                </div>}
            </Tab>
            <Tab
              eventKey="Create/ViewProposals"
              title={`Create / View Proposals`}
            >
              {isLoading ?
                <div className="p-sm-4 text-center">
                  <img
                    src={`${config.baseUrl}images/loader.gif`}
                    width="30px"
                    alt=""
                  />
                </div>
                :
                <div>
                  <Row>
                    <Col md={12} lg={12} className="">
                      <Zoom>
                        <div className="listed">
                          <Table responsive className="bg-transparent text-white border-dark">
                            <thead>
                              <tr>
                                <th>Name</th>
                                <th>Chain</th>
                                <th>Price</th>
                                <th>Reason</th>
                                <th>Proposal Status</th>

                              </tr>
                            </thead>
                            <tbody>
                              {filterListed.swap &&
                                filterListed.swap.length > 0 ? (
                                filterListed.swap.map((item) => (
                                  <tr
                                    key={item.id}
                                    style={{
                                      border:
                                        item.type === "SPECIAL INFI SWAP"
                                          ? "2px solid #00bfff"
                                          : "",
                                      boxShadow:
                                        item.type === "SPECIAL INFI SWAP"
                                          ? "0 0 8px #00bfff"
                                          : "",
                                      color: "#fff",
                                      transition: "box-shadow 0.3s ease",
                                    }}
                                  >
                                    <td>
                                      <div className="d-flex align-items-center lh-1">
                                        <div className="me-2">
                                          <img
                                            src={`${config.imagePath}${item.brand_logo}`}
                                            width="28px"
                                            alt="logo"
                                          />
                                        </div>
                                        <div className="lh-1">
                                          <h5 className="mb-0">
                                            {item.pair_name}
                                          </h5>
                                        </div>
                                      </div>
                                    </td>
                                    <td>{item.chainName}</td>
                                    <td >
                                      {isLoading ? (
                                        <div className="p-sm-4 text-center">
                                          <img
                                            src={`${config.baseUrl}images/loader.gif`}
                                            width="30px"
                                            alt=""
                                          />
                                        </div>
                                      ) : item.pair_name ===
                                        `${item.token_name}/INFI` ? (
                                        `${formatPrice(
                                          item.TOKEN_PRICE_INFI_SWAP
                                        )} ${item.token_name}/INFI`
                                      ) : (
                                        `$${formatPrice(item.TOKEN_PRICE_SWAP)}`
                                      )}
                                    </td>
                                    <td>
                                       <span className="text-danger">Scam</span>
                                    </td>
                                    <td className="text-nowrap">
                                  
                                        {isLoading ? (
                                          <div className="p-sm-4 text-center">
                                            <img
                                              src={`${config.baseUrl}images/loader.gif`}
                                              width="30px"
                                              alt=""
                                            />
                                          </div>
                                        ) : item.pair_name ===
                                          `${item.token_name}/INFI` ? (
                                          item.SWAP_INFI_STATUS ? (
                                            <>
                                              <span
                                                style={{
                                                  height: "8px",
                                                  width: "8px",
                                                  backgroundColor: "red",
                                                  borderRadius: "50%",
                                                  display: "inline-block",
                                                  marginRight: "5px",
                                                }}
                                              ></span>
                                              Paused
                                            </>
                                          ) : (
                                            <>
                                              <span
                                                style={{
                                                  height: "8px",
                                                  width: "8px",
                                                  backgroundColor: "green",
                                                  borderRadius: "50%",
                                                  display: "inline-block",
                                                  marginRight: "5px",
                                                }}
                                              ></span>
                                              Active
                                            </>
                                          )
                                        ) : item.SWAP_STATUS ? (
                                          <>
                                            <span
                                              style={{
                                                height: "8px",
                                                width: "8px",
                                                backgroundColor: "red",
                                                borderRadius: "50%",
                                                display: "inline-block",
                                                marginRight: "5px",
                                              }}
                                            ></span>
                                            Paused
                                          </>
                                        ) : (
                                          <>
                                            <span
                                              style={{
                                                height: "8px",
                                                width: "8px",
                                                backgroundColor: "green",
                                                borderRadius: "50%",
                                                display: "inline-block",
                                                marginRight: "5px",
                                              }}
                                            ></span>
                                            Active
                                          </>
                                        )}

                                      <Button
                                      className="ms-4"
                                        variant="dark"
                                        onClick={(e) => {
                                          if (
                                            item.pair_name ===
                                            `${item.token_name}/INFI`
                                          ) {
                                            openInfiSwapModule(
                                              e,
                                              item.id,
                                              item.token_name
                                            );
                                          } else {
                                            openSwapModule(
                                              e,
                                              item.id,
                                              item.token_name
                                            );
                                          }
                                        }}
                                        disabled={
                                          item.pair_name ===
                                            `${item.token_name}/INFI`
                                            ? item.SWAP_INFI_STATUS
                                            : item.SWAP_STATUS
                                        }
                                      >
                                        View
                                      </Button>
                                    </td>

                                  </tr>
                                ))
                              ) : (
                                <tr>
                                  <td
                                    colSpan="7"
                                    className="text-center"
                                    style={{ color: "white", fontWeight: "bold" }}
                                  >
                                    No listed projects available
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </Table>
                        </div>
                      </Zoom>
                    </Col>
                  </Row>
                </div>}
            </Tab>
          </Tabs>
        </Container>
      </section>
    </>
  );
}
